import React from "react";
import OptimizedImage from "./OptimizedImage";

const About = () => (
    <section id="about" className="px-4">
        <div className="max-w-7xl mx-auto bg-[#0f172a] rounded-3xl p-8 md:p-14 grid md:grid-cols-2 gap-12 items-center">

            {/* LEFT CONTENT */}
            <div data-aos="fade-up">
                <h3 className="text-4xl md:text-5xl font-bold text-white mb-6">
                    Grow, Prosper and Excel
                </h3>

                <p className="text-gray-300 mb-8 max-w-lg">
                    We create educational opportunities for personal growth, prosperity,
                    and excellence while certifying applicable competencies for the
                    future.
                </p>

                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-10">
                    <li className="flex items-start gap-3">
                        <span className="w-9 h-9 flex items-center justify-center rounded-full bg-green-500/20 text-green-400">
                            <i className="bi bi-mortarboard-fill"></i>
                        </span>
                        <span className="text-white">
                            School of Postgraduate Studies
                        </span>
                    </li>

                    <li className="flex items-start gap-3">
                        <span className="w-9 h-9 flex items-center justify-center rounded-full bg-lime-400/20 text-lime-400">
                            <i className="bi bi-lightbulb-fill"></i>
                        </span>
                        <span className="text-white">
                            Institute for Research & Development
                        </span>
                    </li>

                    <li className="flex items-start gap-3">
                        <span className="w-9 h-9 flex items-center justify-center rounded-full bg-emerald-400/20 text-emerald-400">
                            <i className="bi bi-briefcase-fill"></i>
                        </span>
                        <span className="text-white">
                            School of Business & Development Studies
                        </span>
                    </li>
                </ul>

                <a
                    href="/courses"
                    className="inline-flex items-center gap-2 bg-gradient-to-r from-green-500 to-lime-400 text-black font-semibold px-6 py-3 rounded-lg hover:opacity-90 transition"
                >
                    Learn more
                    <i className="bi bi-arrow-right"></i>
                </a>
            </div>

            {/* RIGHT VISUAL STACK */}
            <div
                className="relative grid grid-cols-2 gap-6"
                data-aos="fade-left"
                data-aos-delay="200"
            >
                {/* Abstract card */}
                <div className="col-span-1 h-56 rounded-[28px] overflow-hidden shadow-xl group animate-float">
                    <OptimizedImage
                        src="/assets/img/prog-2.jpg"
                        alt="ARU academic programs preview"
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                        width={400}
                        height={224}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/25 to-transparent" />
                </div>

                {/* Main image card */}
                <div className="col-span-1 row-span-2 rounded-[28px] overflow-hidden shadow-2xl group animate-float-delayed">
                    <OptimizedImage
                        src="/assets/img/lady_grad.jpg"
                        alt="Successful graduate - Africa Research University"
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                        width={400}
                        height={480}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
                </div>

                {/* Accent card */}
                <div className="col-span-1 h-44 rounded-[28px] overflow-hidden shadow-xl group animate-float">
                    <OptimizedImage
                        src="/assets/img/promotion-1.jpg"
                        alt="ARU student promotion and events"
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                        width={400}
                        height={176}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                </div>
            </div>

        </div>
    </section>
);

export default About;
